<template>
  <section>
    <b-modal width="680px" :active.sync="active">
      <div class="card" style="border-radius: 5px; padding: 16px;">
        <h2 style="font-size: x-large; padding: 8px;">次回アクション設定</h2>
        <div style="text-align: left; height: 440px; overflow-y: scroll; position: relative;">
          <div style="overflow-y: auto;">
            <b-tabs v-model="activeTab">
              <b-tab-item label="アクション">
                <div class="tab-contents">
                  <div>
                    <p>アクションを選択してください。</p>
                    <select class="select" v-model="selectAction" style="max-width: 160px; min-width: 160px; margin-top: 8px;">
                      <option :value="act" v-for="(act, idxP) in action" :key="idxP">{{act.name}}</option>
                    </select>
                  </div>
                  <template v-if="selectAction">
                    <div style="display: flex; align-items: center; margin-top: 8px;">
                      <p>本アクションは</p>
                      <template>
                        <p v-if="selectAction.type === 0" style="font-weight: bold; margin-left: 8px;">
                          <i class="mdi mdi-email"></i>
                          メール送信アクション
                        </p>
                        <p v-else-if="selectAction.type === 1" style="font-weight: bold; margin-left: 8px;">
                          <i class="mdi mdi-email-variant"></i>
                          SMS送信アクション
                        </p>
                        <p v-else-if="selectAction.type === 2" style="font-weight: bold; margin-left: 8px;">
                          <i class="mdi mdi-phone"></i>
                          電話日程設定アクション
                        </p>
                      </template>
                      <p style="margin-left: 8px;">となります。</p>
                    </div>
                  </template>
                </div>
              </b-tab-item>
              <b-tab-item label="アクション内容" :disabled="!selectAction">
                <div class="tab-contents">
                  <template v-if="selectAction">
                    <h3 style="margin-bottom: 16px; font-weight: bold;">{{selectAction.name}}</h3>
                    <p v-if="selectAction.type === 0||selectAction.type === 1" style="margin-bottom: 16px;"><span style="font-weight: bold;">{{sk.name}}</span>様に下記の内容をお送りいたします。</p>
                    <div class="tab-box-right" style="flex-wrap: wrap;">
                      <SelectMemberTable
                        :isCalendar="true" v-if="selectAction.type === 2"
                        :users = users
                        :parameterHash="calParameter.user_hash"
                        :calParameter="calParameter"
                        :selfUser="user"
                        :calendarSettings="calendarSettings"
                        :isSync="true"
                        :selectedMember="calParameter"
                        :isSingelSelect="true"
                        :usersStatusAPI="usersStatusAPI"
                        @createCalendarSettingsSelectMember="addUserHash"
                        style="height: 250px;"/>
                      </div>
                    <p v-if="selectAction.type === 2" style="margin-bottom: 16px;"><span style="font-weight: bold;">{{sk.name}}</span>様への電話の予定を以下の内容でカレンダーに追加いたします。</p>
                    <template v-if="selectAction.type === 0 && !selectAction.from_email">
                      <p style="color: red;">エラー：From内容が記載されておりません。ご確認をお願いいたします。</p>
                    </template>
                    <template v-if="selectAction.type === 1 && !selectAction.from_sms_name">
                      <p style="color: red;">エラー：送信元が記載されておりません。ご確認をお願いいたします。</p>
                    </template>
                    <div v-if="selectAction.type === 0||selectAction.type === 1" style="font-size: 14px; border: solid thin #ccc; padding: 8px; max-height: 400px; overflow-y: scroll;">
                      <p v-if="selectAction.type === 0">件名: {{selectAction.email_subject}}</p>
                      <p v-if="selectAction.type === 0">FROM: {{selectAction.from_email}}</p>
                      <p v-else-if="selectAction.type === 1">送信元: {{selectAction.from_sms_name}}</p>
                      <p v-if="selectAction.type === 0">
                          TO: {{sk.email}}
                      </p>
                      <p v-else-if="selectAction.type === 1">
                          TO: {{sk.tel}}
                      </p>
                      <p v-if="selectAction.type === 0" style="margin-bottom: 8px;">CC: {{selectAction.cc_email}}</p>
                      <b-tabs type="is-toggle" size="is-small">
                        <b-tab-item label="プレビュー" size="is-small">
                          <p
                            style="margin-top: 8px; padding: 8px; border: solid thin #ccc; white-space: pre-wrap;"
                            v-html="makeContent(selectAction)"
                          >
                          </p>
                        </b-tab-item>
                        <b-tab-item v-if="selectAction.type === 0||selectAction.type === 1" label="編集" size="is-small">
                          <WYSIWYGAndPlainTextEditer
                            ref="contentEditer"
                            style="height: calc(100% - 400px);"
                            v-model="selectAction.email_content"
                            :isEditingPlainText="selectAction.type == 1"/>
                        </b-tab-item>
                      </b-tabs>
                    </div>
                    <div v-if="selectAction.type === 2" style="font-size: 14px; border: solid thin #ccc; padding: 8px; max-height: 400px; overflow-y: scroll;">
                      <div style="font-weight: bold;">タイトル</div>
                      <p> 
                        {{this.sk.name}}様に電話
                      </p>
                      <div style="font-weight: bold; padding-top: 16px;">メモ</div>
                      <div v-if="this.sk.tel">
                        <p>以下応募者情報となります<br>
                        名前:{{this.sk.name}}<br>
                        電話番号:{{this.sk.tel}}</p>
                      </div>
                      <div v-else>
                        <p>以下応募者情報となります<br>
                        名前:{{this.sk.name}}<br>
                        電話番号:未登録</p>
                      </div>
                    </div>
                  </template>
                </div>
              </b-tab-item>
              <b-tab-item label="実行日時" :disabled="!selectAction">
                <div class="tab-contents">
                  <template v-if="selectAction">
                    <div style="display: flex; align-items: center">
                      <b-datepicker v-if="selectAction.type === 0||selectAction.type === 1"
                        style="width: 150px;"
                          v-model="selectedDate"
                          @input="checkTime()"
                          locale="ja-JP"
                          placeholder="クリックで選択できます。"
                          icon="calendar-today"
                          :day-names="['日', '月', '火', '水', '木', '金', '土']"
                          :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                          :min-date="new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())"
                          trap-focus>
                      </b-datepicker>
                      <div v-if="selectAction.type === 2" class="tab-box-right">
                        <b-datetimepicker
                          rounded
                          v-model="selectedTelStartDate"
                          placeholder="開始日時"
                          icon="calendar-today"
                          :min-datetime="new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())"
                          horizontal-time-picker>
                        </b-datetimepicker>
                        <p style="display: flex; justify-content: center; align-items: center; margin: 0 8px;"> ～ </p>
                        <b-datetimepicker
                          rounded
                          v-model="selectedTelEndDate"
                          placeholder="終了日時"
                          icon="calendar-today"
                          :min-datetime="new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())"
                          horizontal-time-picker>
                        </b-datetimepicker>
                      </div>
                      <div v-if="selectAction.type === 0||selectAction.type === 1">
                        <input style="width: 110px;" class="input" type="time" v-model="selectedTime" @blur="checkTime()">
                        <div style="display: inline-block; padding: 8px;">
                          に送付されます。
                        </div>
                      </div>
                      <span v-if="selectAction.type === 2" style="margin-left: 8px;">カレンダーに追加されます。</span>
                    </div>
                    <p v-if="selectAction.type === 0||selectAction.type === 1" style="margin-top: 16px; font-size: 14px;">現在時刻よりも前時点には設定できません。</p>
                  </template>
                </div>
              </b-tab-item>
              <b-tab-item label="内容確認" :disabled="!selectAction">
                <div class="tab-contents">
                  <div style="border:1px solid lightgray; padding: 8px; margin-top: 4px;">
                    <template v-if="selectAction">
                      <div style="display: flex; align-items: center;">
                        <p class="item-name">アクション名:</p>
                        <span style="font-weight: bold">{{selectAction.name}}</span>
                      </div>
                      <div style="display: flex; align-items: center; margin-top: 16px;">
                        <p class="item-name" v-if="selectAction.type===0">実行するアクション:</p>
                        <span v-if="selectAction.type===0" style="font-weight: bold">
                          <i class="mdi mdi-email"></i>
                          メール送信アクション
                        </span>
                      </div>
                    </template>
                    <div style="display: flex; align-items: center; margin-top: 16px;">
                      <p class="item-name">内容:</p><span style="color: blue; cursor: pointer" @click="activeTab=1">クリックで確認</span>
                    </div>
                    <div style="display: flex; align-items: center; margin-top: 16px;">
                      <template v-if="selectAction">
                        <div v-if="selectAction.type === 2">
                          <p class="item-name">カレンダーの設定日:</p>
                          <div v-if="selectedTelStartDate && selectedTelEndDate">
                            <span style="font-weight: bold">{{ dateTimeFormat(selectedTelStartDate) }}〜</span>
                            <span style="font-weight: bold">{{ dateTimeFormat(selectedTelEndDate) }}</span>
                          </div>
                        </div>
                        <div v-else>
                          <p class="item-name">実行日時:</p>
                          <span style="font-weight: bold">{{ dateFormat(selectedDate) }}</span>
                          <span style=" margin-left: 8px; font-weight: bold">{{ selectedTime }}</span>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div style="margin-top: 32px; font-size: 14px;">
                    <div v-if="isSetting">
                      <p>上記内容にお間違いがなければを「変更する」クリックでアクションを登録します。</p>
                      <p>実行日時を現在時刻よりも前時点を設定した場合、即時送付されます。</p>
                    </div>
                    <div v-else>
                      <p>上記内容にお間違いがなければを「登録する」クリックでアクションを登録します。</p>
                      <p>実行日時を現在時刻よりも前時点を設定した場合、即時送付されます。</p>
                    </div>
                  </div>
                </div>
              </b-tab-item>
            </b-tabs>
          </div>
          <div style="position: absolute; bottom: 0; width: 100%; display: flex; justify-content: flex-end;">
            <button class="button is-light" @click="active=false">キャンセル</button>
            <button v-if="activeTab === 3 && !isSetting && selectAction.type != 2" @click="createRecruitmentFlowActionHistory" style="margin-left: 8px;" class="button is-primary">登録する</button>
            <button v-if="activeTab === 3 && !isSetting && selectAction.type === 2" @click="createRecruitmentFlowTelActionHistory" style="margin-left: 8px;" class="button is-primary">登録する</button>
            <button v-if="activeTab === 3 && isSetting && selectAction.type != 2" @click="updateRecruitmentFlowActionHistory" style="margin-left: 8px;" class="button is-primary">変更する</button>
            <button v-else-if="activeTab < 3" style="margin-left: 8px;" class="button" @click="activeTab++" :disabled="!selectAction">次へ</button>
            <button v-if="isSetting && selectAction.type === 2" @click="deleteRecruitmentFlowActionHistory(true)" style="margin-left: 8px;" class="button is-danger">予定の取り消し</button>
            <button v-if="isSetting && selectAction.type !== 2" @click="deleteRecruitmentFlowActionHistory(false)" style="margin-left: 8px;" class="button is-danger">予定の取り消し</button>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import SelectMemberTable from '@/components/molecules/tables/SelectMemberTable'
import WYSIWYGAndPlainTextEditer from '@/components/ui/WYSIWYGAndPlainTextEditer'
import { mapState } from "vuex"
import moment from 'moment'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  components: {
    SelectMemberTable,
    WYSIWYGAndPlainTextEditer
  },
  mixins: [
    controlLogMixin
  ],
  name: 'ModalActionCheck',
  computed: {
    ...mapState('calendar', ['isGoogleAuth', 'isGaroonAuth','isCybozuAuth','isMSOfficeAuth']),
    ...mapState('auth', ['user', 'users', 'departments', 'positions','calendarSettings', 'usersStatusAPI']),
    selectedDateTime() {
      if (typeof this.selectedTime === "string") {
        const hour = Number(this.selectedTime.split(":")[0])
        const min = Number(this.selectedTime.split(":")[1])
        const date = new Date(this.selectedDate)
        date.setHours(hour)
        date.setMinutes(min)
        return date
      }
      return null
    }
  },
  data () {
    return {
      calParameter: {},
      active: false,
      action: null,
      sk: null,
      options: {
        theme: 'snow',
        placeholder: '内容を入力...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }]]
        }
      },
      selectAction: null,
      selectedDate: null,
      selectedTelStartDate: null,
      selectedTelEndDate: null,
      selectedTime: null,
      activeTab: 0,
      isSetting: false,
      checkTimeIntervalID: undefined
    }
  },
  watch: {
    active() {
      if (this.active) {
        this.setResetModalData()
        this.setLatestInfo(this.sk.recruitment_flow_action_history)
        this.checkTimeIntervalID = setInterval(() => this.checkTime(), 10000);
      }
      else {
        clearInterval(this.checkTimeIntervalID)
      }
    },
    selectAction() {
      this.setInitDateAndTime()
    },
  },
  methods: {
    addUserHash (data) {
      this.calParameter.user_hash = [data.user.user_hash]
    },
    isImmediate (date) {
      return moment(date).format("YYYY/MM/DD")=== moment(new Date()).format("YYYY/MM/DD")
    },
    setResetModalData () {
      this.selectAction = null
      this.selectedDate = null
      this.selectedTime = null
      this.activeTab = 0
    },
    setInitDateAndTime () {
      if (this.selectAction && !this.selectedDate) {
        const selectedDate = new Date(
          new Date()
            .setDate( new Date()
            .getDate() + this.selectAction.delay_days )
        )
        selectedDate.setHours(selectedDate.getHours() + this.selectAction.hours_later)
        this.selectedDate = selectedDate
        if (this.selectAction.delay_time) {
          const hour = this.selectAction.delay_time.split(":")[0]
          const min = this.selectAction.delay_time.split(":")[1]
          this.selectedTime = `${hour}:${min}`
        } else if (this.selectAction.hours_later || this.selectAction.hours_later === 0) {
          const date = new Date()
          const time = new Date(date.setHours(date.getHours() + Number(this.selectAction.hours_later)))
          const hour = String(time.getHours()).length === 1
            ? '0' + time.getHours()
            : time.getHours()
          const min = String(time.getMinutes()).length === 1
            ? '0' + time.getMinutes()
            : time.getMinutes()
          this.selectedTime = `${hour}:${min}`
        }
      }
    },
    dateFormat (date) {
      return moment(date).format("YYYY/MM/DD")
    },
    dateTimeFormat (date) {
      return moment(date).format("YYYY/MM/DD HH:mm")
    },
    toggle () {
      this.active = true
    },
    checkTime() {
      let now = new Date()
      if (this.selectedDateTime < now) {
        this.selectedDate = now
        this.selectedTime = now.toTimeString().substring(0, 5)
      }
    },
    createRecruitmentFlowActionHistory () {
      this.checkTime()
      this.sendControlLog('応募者アクション設定', '次回アクション設定モーダルにて、「登録する」ボタンをクリックした。')
      let createAction = {
        seeker: this.sk.id,
        action: this.selectAction.pk,
        email_content: this.selectAction.email_content,
        ended_at: this.selectedDateTime,
        is_finished: false,
        finished_status: 0,
        calendarId: null,
        target_calendar_user_hash: null,
      }
      this.$store.dispatch('directtalk/createRecruitmentFlowActionHistory', createAction)
        .then (() => {
          this.active = false
        })
    },
    createRecruitmentFlowTelActionHistory () {
      if ((this.selectedTelStartDate - this.selectedTelEndDate) === 0){
        alert("開始日時と終了日時を1分以上空けて設定してください。")
        return
      }
      if (this.selectedTelStartDate > this.selectedTelEndDate){
        alert("開始日時は終了日時より前に設定してください。")
        return
      }
      let createAction = {
        seeker: this.sk.id,
        action: this.selectAction.pk,
        email_content: this.selectAction.email_content,
        ended_at: null,
        selectedTelStartDate :this.selectedTelStartDate,
        selectedTelEndDate : this.selectedTelEndDate,
        is_finished: false,
        finished_status: 0,
        target_calendar_user_hash: this.calParameter.user_hash[0],
      }
      let calendarType = null
      for (const u of this.users) {
        if (u.user_hash == this.calParameter.user_hash[0]){
          if (u.is_google_calendar_auth) {
            calendarType = "google"
          } else if (u.is_garoon_auth) {
            calendarType = "garoon"
          } else if (u.is_cybozu_office_auth) {
            calendarType = "cybozu"
          } else if (u.is_msoffice_auth) {
            calendarType = "msoffice"
          } else if (u.is_gsession_auth) {
            calendarType = "gsession"
          } else if (u.is_lineworks_auth) {
            calendarType = "lineworks"
          } else if (u.is_nolinkage_auth) {
            calendarType = "nolinkage"
          } else {
            alert("電話のアクションを設定する場合はカレンダー連携を行ってください。")
            return
          }     
        }
      }
      this.sendControlLog('応募者アクション設定', '次回アクション設定モーダルにて、「登録する」ボタンをクリックした。')
      let tempInfo = {
        attendees   :[this.calParameter.user_hash[0]],
        calendarType :calendarType,
        title :this.sk.name + '様に電話',
        description :this.sk.tel? '以下応募者情報となります\n名前:' + this.sk.name + '\n電話番号:' + this.sk.tel:'以下応募者情報となります\n名前:' + this.sk.name + '\n電話番号:未登録',
        start :this.selectedTelStartDate,
        end :this.selectedTelEndDate,
        user_hash :this.calParameter.user_hash[0]
      }
      if (calendarType = "gsession"){
        tempInfo.description = this.sk.tel? '以下応募者情報となります　　　名前:' + this.sk.name + '　　　電話番号:' + this.sk.tel:'以下応募者情報となります　　　名前:' + this.sk.name + '　　　電話番号:未登録'
      }
      this.$store.dispatch('calendar/createSchedules', tempInfo)
        .then ((data) => {
          this.active = false
          createAction.calendarId=data.id
          this.$store.dispatch('directtalk/createRecruitmentFlowActionHistory', createAction)
        })
    },

    updateRecruitmentFlowActionHistory () {
      this.checkTime()
      this.sendControlLog('応募者アクション変更', '次回アクション設定モーダルにて、「変更する」ボタンをクリックした。')
      const data = {
        pk: this.sk.recruitment_flow_action_history[this.sk.recruitment_flow_action_history.length - 1].id,
        action: this.selectAction.pk,
        email_content: this.selectAction.email_content,
        ended_at: this.selectedDateTime,
      }
      this.$store.dispatch('directtalk/updateRecruitmentFlowActionHistory', data)
        .then (() => {
          this.active = false
        })
    },
    deleteRecruitmentFlowActionHistory (isTelAction) {
      this.sendControlLog('応募者アクション取り消し', '次回アクション設定モーダルにて、「予定の取り消し」ボタンをクリックした。')
      const pk = this.sk.recruitment_flow_action_history[this.sk.recruitment_flow_action_history.length - 1].id
      if(!isTelAction){
        this.$store.dispatch('directtalk/deleteRecruitmentFlowActionHistory', pk)
        this.$emit('delete-recruit-flow-action', pk)
        this.active = false
      } else{
          const targetCalendarUserHash = this.sk.recruitment_flow_action_history[this.sk.recruitment_flow_action_history.length - 1].target_calendar_user_hash
          let calendarType = null
          for (const u of this.users) {
            if (u.user_hash == targetCalendarUserHash ){
              if (u.is_google_calendar_auth) {
                calendarType = "google"
              } else if (u.is_garoon_auth) {
                calendarType = "garoon"
              } else if (u.is_cybozu_office_auth) {
                calendarType = "cybozu"
              } else if (u.is_msoffice_auth) {
                calendarType = "msoffice"
              } else if (u.is_gsession_auth) {
                calendarType = "gsession"
              } else if (u.is_lineworks_auth) {
                calendarType = "lineworks"
              } else if (u.is_nolinkage_auth) {
                calendarType = "nolinkage"
              }
            }
          }
          const info = {
            id: this.sk.recruitment_flow_action_history[this.sk.recruitment_flow_action_history.length - 1].calendarId,
            calendarType: calendarType,
            type:'delete',
            isViaApplicantTable:true,
            user_hash:targetCalendarUserHash,
          }
          this.$store.dispatch('calendar/updateSchedules', info)
            .then (() => {
              this.$store.dispatch('directtalk/deleteRecruitmentFlowActionHistory', pk)
              this.$emit('delete-recruit-flow-action', pk)
              this.active = false
            })
      }
    },
    makeContent (action) {
      let content = ''
      if (action.type === 0) {
        content = action.email_content
      }
      else if (action.type === 1 && this.$refs.contentEditer) {
        content = this.$refs.contentEditer.plainText
      }

      // ここ使うのか検討（ここから）
      let botUri = process.env.OWN_ENDPOINT + '/single/仮のURLです'
      let storyUri = process.env.OWN_ENDPOINT + '/recruits/story/仮のURLです'
      let receivedUri = process.env.OWN_ENDPOINT + '/message_login/' + this.sk.id
      // ここ使うのか検討（ここまで）
      return content
      .replace(/__name__/g, this.sk.name)
      .replace(/__bot__/g, botUri)
      .replace(/__robo_url__/g, botUri)
      .replace(/__story__/g, storyUri)
      .replace(/__received_form__/g, receivedUri)
    },
    latestIsFinished (histories) {
      if (typeof histories === "object") {
        if (histories[histories.length - 1]) {
          return histories[histories.length - 1].is_finished
        }
      }
      return ''
    },
    setLatestInfo (histories) {
      if (typeof histories === "object") {
        if (histories[histories.length - 1]) {
          if (!histories[histories.length - 1].is_finished) {
            for (const act of this.action) {
              if  (act.pk === histories[histories.length - 1].action) {
                this.selectAction = histories[histories.length - 1].action_data
                if (histories[histories.length - 1].ended_at) {
                  const selectedDate = new Date(
                    histories[histories.length - 1].ended_at
                  )
                  this.selectedDate = selectedDate
                  const hour 
                    = String(selectedDate.getHours()).length === 1
                      ? '0' + selectedDate.getHours()
                      : selectedDate.getHours()
                  const min 
                    = String(selectedDate.getMinutes()).length === 1
                      ? '0' + selectedDate.getMinutes()
                      : selectedDate.getMinutes()
                  this.selectedTime = `${hour}:${min}`
                }
                this.isSetting = true;
                return
              }
            }
          }
        }
      }
      this.isSetting = false;
    }
  }
}
</script>

<style lang='scss' scoped>

.modal-media {
  height: 300px;
  width: 100%;
  object-fit: cover;
}

.title {
  font-size: 22px;
  font-weight: 700;
  padding: 20px;
  border-bottom: solid thin #ccc;
}

.card-header-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tab-contents {
  padding: 4px;
  overflow-y: auto;
  height: 360px;
}

.item-name {
  width: 160px;
}

</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Manage/ModalActionCheck.vue